module.exports = __webpack_public_path__ + "assets/img/report-data-bg-1.32b4e9e9.png";